import { Modal } from 'bootstrap';
import { speakText, pauseSpeech, resumeSpeech } from './utils';

declare var Prism: any;
declare var marked: any;
declare var DOMPurify: any;
declare var mermaid: any;
declare var katex: any;

const GITHUB_USERNAME = "MangaD";

const searchInput = document.getElementById("searchInput");
const gistList = document.getElementById("gistList");
const gistCountSelector = document.getElementById("gistCountSelector");
let allGists = [];

function configure() {

    Prism.plugins.autoloader.languages_path = 'https://cdn.jsdelivr.net/npm/prismjs/components/';
    Prism.plugins.autoloader.use_minified = true;
    // Preload common languages for reliability
    /*Prism.plugins.autoloader.loadLanguages([
      'python', 'cpp', 'javascript', 'bash', 'json', 'html', 'css', 'java', 'csharp', 'go', 'ruby', 'php'
    ]);*/

    marked.setOptions({
        gfm: true,
        breaks: true,
        langPrefix: 'language-'
    });

    mermaid.initialize({ startOnLoad: false });

    marked.use({
      async: false,
      breaks: true,
      gfm: true,
      extensions: [{
        name: 'math',
        level: 'block',
        start(src) {
          return src.match(/^ {0,3}\$\$/m)?.index;
        },
        tokenizer(src) {
          const match = /^ {0,3}\$\$[ \t]*(?:\r?\n)?([\s\S]*?)\$\$[ \t]*(?:\r?\n|$)/.exec(src);
          if (!match) return;
          return { type: 'math', raw: match[0], text: match[1].trim() };
        },
        renderer(token) {
          return katex.renderToString(token.text, { displayMode: true, throwOnError: false });
        }
      }],
      walkTokens: (token) => {
        if (token.type === 'code' && token.lang === 'math') {
          token.text = katex.renderToString(token.text, { throwOnError: false });
          token.type = 'html';
        } else if (token.type === 'code' && token.lang === 'mermaid') {
          const id = 'mermaid-' + Math.random().toString(36).substring(2, 15);
          token.text = `<div class="mermaid" id="${id}">${token.text}</div>`;
          token.type = 'html';
        } else if (token.type === 'code' && token.lang === 'html+iframe') {
          token.text = `<iframe srcdoc="${encodeURIComponent(token.text)}" frameborder="0" width="100%" onload="iFrameResize({ log: false }, this)"></iframe>`;
          token.type = 'html';
        } else if (token.type === 'code' && token.lang === 'jsfiddle') {
          token.text = `<iframe width="100%" height="300" src="https://jsfiddle.net/${token.text}/embedded/js,html,css,result" frameborder="0" allowfullscreen></iframe>`;
          token.type = 'html';
        } else if (token.type === 'code' && token.lang === 'codepen') {
          // MangaD - Escape the end of the script tag to prevent HTML parsing issues
          // https://github.com/sveltejs/svelte/issues/3039#issuecomment-502921428
          token.text = `<p data-height="300" data-theme-id="light" data-slug-hash="${token.text}" data-default-tab="result" data-user="MangaD" data-embed-version="2" class="codepen"></p><script async src="https://static.codepen.io/assets/embed/ei.js"><\/script>`;
          token.type = 'html';
        } else if (token.type === 'code' && token.lang === 'youtube') {
          token.text = `<iframe width="100%" height="315" src="https://www.youtube.com/embed/${token.text}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
          token.type = 'html';
        } else if (token.type === 'code' && token.lang === 'colab') {
          token.text = `<iframe src="https://colab.research.google.com/drive/${token.text}?usp=sharing" width="100%" height="500" frameborder="0" allowfullscreen></iframe>`;
          token.type = 'html';
        } else if (token.type === 'code' && token.lang === 'replit') {
          token.text = `<iframe height="500px" width="100%" src="https://replit.com/@${token.text}?embed=true" scrolling="no" frameborder="0" allowfullscreen></iframe>`;
          token.type = 'html';
        } else if (token.type === 'code' && token.lang === 'observable') {
          token.text = `<iframe width="100%" height="500" frameborder="0" src="https://observablehq.com/embed/${token.text}?cell=*"></iframe>`;
          token.type = 'html';
        } else if (token.type === 'code' && token.lang === 'nbviewer') {
          token.text = `<iframe src="https://nbviewer.org/url/${token.text}" width="100%" height="600" frameborder="0" allowfullscreen></iframe>`;
          token.type = 'html';
        }
      }
    });

    gistCountSelector.addEventListener("change", () => {
      renderGists(allGists);
    });

    searchInput.addEventListener("input", () => {
      const query = (searchInput as any).value.toLowerCase();
      const filtered = allGists.filter(gist => (gist.description || "").toLowerCase().includes(query));
      renderGists(filtered);
    });
}

function renderMarkdownTo(markdown: string) {
    let renderedText = DOMPurify.sanitize(marked.parse(markdown));
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = renderedText;
    //loadPrismInMd(tempDiv);
    return tempDiv.innerHTML;
}

function loadPrismInMd(container: HTMLElement) {
    container.querySelectorAll('pre code').forEach(code => {
        const pre = code.parentElement;
        if (!pre.classList.contains('line-numbers')) {
        pre.classList.add('line-numbers');
        }
        let language = code.className.match(/language-(\w+)/)?.[1];
        language = language === 'c++' ? 'cpp' : language;
        Prism.highlightElement(code);
    });
}

/**
 * The GitHub API does have rate limits, and aggressively fetching many pages can cause
 * issues if you're not authenticated. So we don't fetch with JS, but rather use a PHP script
 * 
 * 🔐 GitHub API Rate Limits (as of 2025):
 *
 * - Unauthenticated requests:
 * ⛔ 60 requests per hour per IP
 *
 * - Authenticated requests (with a personal access token):
 * ✅ Up to 5,000 requests per hour
 */
/*
async function fetchGists() {
    try {
    let page = 1;
    const perPage = 100;
    let fetched = [];
    while (true) {
    const res = await fetch(`https://api.github.com/users/${GITHUB_USERNAME}/gists?per_page=${perPage}&page=${page}`);
    const data = await res.json();
    if (!Array.isArray(data) || data.length === 0) break;
    fetched = fetched.concat(data);
    if (data.length < perPage) break;
    page++;
    }
    allGists = fetched;
    document.getElementById("gistCount").textContent = `Total Gists: ${allGists.length}`;
    renderGists(allGists);
    } catch (error) {
    console.error("Error fetching gists:", error);
    gistList.innerHTML = "<p>Error loading gists.</p>";
    }
}*/

async function fetchGists() {
    try {
        gistList.innerHTML = "<p>Loading...</p>"; // Temporary loading text

        const baseUrl = window.location.hostname === "localhost"
            ? "https://davidg.cc/"
            : "";

        // chmod 644 to allow public access
        const res = await fetch(`${baseUrl}gists.php`);

        const data = await res.json();
        allGists = data.filter(gist => gist.public !== false);
        document.getElementById("gistCountNumber").textContent = `${allGists.length}`;
        renderGists(allGists);
    } catch (error) {
        console.error("Error fetching gists:", error);
        gistList.innerHTML = "<p>Error loading gists.</p>";
    }
}

async function fetchAllGistFiles(gist) {
    try {
        const fileEntries = Object.entries(gist.files);
        const fileContents = await Promise.all(fileEntries.map(async ([filename, file]) => {
        const res = await fetch((file as any).raw_url);
        if (!res.ok) throw new Error(`Failed to fetch file: ${filename}`);
        const content = await res.text();
        return { filename, content, language: (file as any).language };
        }));
        return fileContents;
    } catch (error) {
        console.error("Error fetching gist files:", error);
        return [];
    }
}

function showModal(title: string, bodyContent: HTMLElement) {
    const modal = document.getElementById("gist-modal");
    const modalTitle = modal.querySelector(".modal-title");
    const modalBody = modal.querySelector(".modal-body");

    destroyGistContentScrollbar();
    modalTitle.textContent = title;
    modalBody.innerHTML = "";
    modalBody.appendChild(bodyContent);
    setupGistContentScrollbar();

    const bootstrapModal = new Modal(modal);
    bootstrapModal.show();
}

function renderGists(gists) {

    destroyGistListScrollbar();

    gistList.innerHTML = "";
    const selectedCount = (gistCountSelector as any).value === "all" ? gists.length : parseInt((gistCountSelector as any).value, 10);
    const limitedGists = gists.slice(0, selectedCount);

    if (limitedGists.length === 0) {
        gistList.innerHTML = "<p>No matching gists found.</p>";
        return;
    }

    limitedGists.forEach(gist => {
        const description = gist.description || "Untitled Gist";
        const div = document.createElement("div");
        div.className = "gist-item";

        const span = document.createElement("span");
        span.textContent = description;
        span.classList.add("gist-title");
        span.setAttribute("aria-label", `View gist: ${description}`);
        span.addEventListener("click", async (e) => {
            e.preventDefault();

            const modalBody = document.createElement("div");
            modalBody.className = "gist";

            const files = await fetchAllGistFiles(gist);
            files.forEach(file => {
                const langDiv = document.createElement("div");
                langDiv.className = "file-type";
                langDiv.innerHTML = `<strong>File:</strong> ${file.filename} (Language: ${file.language || "Unknown"})`;

                const commentsDiv = document.createElement("div");
                commentsDiv.className = "comments-count";
                commentsDiv.innerHTML = `<strong>Comments:</strong> ${gist.comments || 0}`;

                const createdAtDiv = document.createElement("div");
                createdAtDiv.className = "created-at";
                createdAtDiv.innerHTML = `<strong>Created At:</strong> ${new Date(gist.created_at).toLocaleString()}`;

                const updatedAtDiv = document.createElement("div");
                updatedAtDiv.className = "updated-at";
                updatedAtDiv.innerHTML = `<strong>Updated At:</strong> ${new Date(gist.updated_at).toLocaleString()}`;

                const contentDiv = document.createElement("div");
                contentDiv.className = "gist-content";

                if (file.language?.toLowerCase() === "markdown") {
                    const markdownBody = document.createElement("div");
                    markdownBody.className = "markdown-body";
                    markdownBody.innerHTML = renderMarkdownTo(file.content);
                    contentDiv.appendChild(markdownBody);
                    contentDiv.querySelectorAll('.mermaid').forEach(el => mermaid.init(undefined, el));
                    loadPrismInMd(contentDiv);
                } else {
                    const codeBlock = document.createElement("pre");
                    const code = document.createElement("code");

                    const lang = file.language?.toLowerCase() || "text";
                    const prismLang = lang === "c++" ? "cpp" : lang;
                    code.className = `language-${prismLang}`;

                    code.textContent = file.content;

                    codeBlock.className = "line-numbers";
                    codeBlock.appendChild(code);
                    contentDiv.appendChild(codeBlock);

                    Prism.highlightElement(code);
                }

                modalBody.appendChild(langDiv);
                modalBody.appendChild(commentsDiv);
                modalBody.appendChild(createdAtDiv);
                modalBody.appendChild(updatedAtDiv);
                const markdownBodyEl = contentDiv.querySelector('.markdown-body') as HTMLElement;
                const textToSpeak = markdownBodyEl ? markdownBodyEl.textContent || "" : file.content;
                addButtonControlsToGist(modalBody, contentDiv.firstElementChild as HTMLElement, textToSpeak);
                modalBody.appendChild(contentDiv);

                // 👇 Word click listener
                contentDiv.querySelector('.markdown-body').addEventListener('click', (e) => {
                  const sel = window.getSelection();
                  if (!sel || sel.toString().trim() === '') return;

                  const clickedWord = sel.toString().trim();
                  const startIndex = textToSpeak.indexOf(clickedWord);

                  if (startIndex !== -1 && window.speechSynthesis.speaking) {
                    const remainingText = textToSpeak.slice(startIndex);
                    speakText(remainingText);
                  }
                });

                showModal(description, modalBody);
            });
        });

        const externalLink = document.createElement("a");
        externalLink.href = gist.html_url;
        externalLink.target = "_blank";
        externalLink.rel = "noopener noreferrer";
        externalLink.style.marginLeft = "10px";
        externalLink.innerHTML = '<i class="fas fa-external-link-alt"></i>'; // Font Awesome icon

        div.appendChild(span);
        div.appendChild(externalLink);
        gistList.appendChild(div);
    });

    setupGistListScrollbar();
}

function destroyGistListScrollbar() {
	if ($("#gistListContainer").hasClass("mCustomScrollbar")) {
		$("#gistListContainer").mCustomScrollbar("destroy");
	}
}

function setupGistListScrollbar() {
	$("#gistListContainer").mCustomScrollbar({
		theme: "minimal-dark",
		axis: "y",
		autoDraggerLength: true
	});
}

function destroyGistContentScrollbar() {
	if ($("#notes .gist-content").hasClass("mCustomScrollbar")) {
		$("#notes .gist-content").mCustomScrollbar("destroy");
	}
}

function setupGistContentScrollbar() {
	$("#notes .gist-content").mCustomScrollbar({
		theme: "minimal-dark",
		axis: "y",
		autoDraggerLength: true
	});
}

function addButtonControlsToGist(container: HTMLElement, contentEl: HTMLElement, content: string = "") {
  if (!container) {
    return;
  }

  // Add zoom controls
  const controlDiv = document.createElement('div');
  controlDiv.className = 'gist-controls';

  const zoomInButton = document.createElement('button');
  zoomInButton.className = 'zoom-in';
  zoomInButton.setAttribute('aria-label', 'Zoom In');
  const zoomInIcon = document.createElement('i');
  zoomInIcon.className = 'fas fa-search-plus';
  zoomInButton.appendChild(zoomInIcon);

  const zoomOutButton = document.createElement('button');
  zoomOutButton.className = 'zoom-out';
  zoomOutButton.setAttribute('aria-label', 'Zoom Out');
  const zoomOutIcon = document.createElement('i');
  zoomOutIcon.className = 'fas fa-search-minus';
  zoomOutButton.appendChild(zoomOutIcon);

  const speakButton = document.createElement("button");
  speakButton.className = "speechBtn";
  speakButton.setAttribute("aria-label", "Speak text");
  const speakIcon = document.createElement('i');
  speakIcon.className = 'fa-solid fa-volume-high';
  speakButton.appendChild(speakIcon);
  speakButton.onclick = () => {
    if (!window.speechSynthesis.speaking) {
      speakText(content);
      speakIcon.className = 'fa-solid fa-pause';

      // Restore icon when speech ends
      const restoreIcon = () => {
        window.speechSynthesis.cancel();
        speakIcon.className = 'fa-solid fa-volume-high';
        window.speechSynthesis.removeEventListener('end', restoreIcon);
        window.speechSynthesis.removeEventListener('cancel', restoreIcon);
      };
      window.speechSynthesis.addEventListener('end', restoreIcon);
      window.speechSynthesis.addEventListener('cancel', restoreIcon);
    } else if (window.speechSynthesis.speaking && !globalThis.isActuallyPaused) {
      pauseSpeech();
      speakIcon.className = 'fa-solid fa-play';
    } else if (globalThis.isActuallyPaused) {
      resumeSpeech();
      speakIcon.className = 'fa-solid fa-pause';
    }
  };

  // Cancel speech when the modal is closed
  const modalEl = document.getElementById("gist-modal");
  if (modalEl) {
    modalEl.addEventListener("hidden.bs.modal", () => {
      window.speechSynthesis.cancel();
      speakIcon.className = 'fa-solid fa-volume-high';
    }, { once: true });
  }

  controlDiv.appendChild(zoomInButton);
  controlDiv.appendChild(zoomOutButton);
  controlDiv.appendChild(speakButton);

  container.appendChild(controlDiv);

  let fontSize = 16; // Default font size in pixels

  zoomInButton.addEventListener('click', () => {
      fontSize += 2;
      contentEl.style.fontSize = `${fontSize}px`;
  });

  zoomOutButton.addEventListener('click', () => {
      fontSize = Math.max(10, fontSize - 2); // Prevent font size from going below 10px
      contentEl.style.fontSize = `${fontSize}px`;
  });
}

export function loadGists() {
    configure();
    fetchGists();
}
